/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerStreamResponseQueryResponse, AiAgentV2ControllerStreamResponsePathParams } from "../../models/aiAgentV2Controller/AiAgentV2ControllerStreamResponse";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { aiAgentV2ControllerStreamResponse } from "../../clients/ai-agent-v2Service/aiAgentV2ControllerStreamResponse";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const aiAgentV2ControllerStreamResponseQueryKey = (requestId: AiAgentV2ControllerStreamResponsePathParams["requestId"]) => [{
  url: '/api/v1/ai-agent-v2/stream/:requestId',
  params: {
    requestId: requestId
  }
}] as const;
export type AiAgentV2ControllerStreamResponseQueryKey = ReturnType<typeof aiAgentV2ControllerStreamResponseQueryKey>;
export function aiAgentV2ControllerStreamResponseQueryOptions(requestId: AiAgentV2ControllerStreamResponsePathParams["requestId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = aiAgentV2ControllerStreamResponseQueryKey(requestId);
  return queryOptions<AiAgentV2ControllerStreamResponseQueryResponse, ResponseErrorConfig<Error>, AiAgentV2ControllerStreamResponseQueryResponse, typeof queryKey>({
    enabled: !!requestId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return aiAgentV2ControllerStreamResponse(requestId, config);
    }
  });
}

/**
 * @description Streams real-time agent events from Redis Streams.
 * @summary Stream agent responses via Server-Sent Events
 * {@link /api/v1/ai-agent-v2/stream/:requestId}
 */
export function useAiAgentV2ControllerStreamResponse<TData = AiAgentV2ControllerStreamResponseQueryResponse, TQueryData = AiAgentV2ControllerStreamResponseQueryResponse, TQueryKey extends QueryKey = AiAgentV2ControllerStreamResponseQueryKey>(requestId: AiAgentV2ControllerStreamResponsePathParams["requestId"], options: {
  query?: Partial<QueryObserverOptions<AiAgentV2ControllerStreamResponseQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? aiAgentV2ControllerStreamResponseQueryKey(requestId);
  const query = useQuery({
    ...aiAgentV2ControllerStreamResponseQueryOptions(requestId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}